import {useState, useEffect} from 'react';

const useAudio = url => {
  const [audio] = useState(typeof (window) === `undefined`?null:new Audio(url));
  // audio.preload="none";
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing, audio]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, [audio]);

  return [playing, toggle];
};

export {useAudio};